import { useState } from 'react';
import { OpenAI, Configuration } from 'openai';

import css from './TnaModuleEdit.module.css';
import { isSame } from '../../../../../services/utils/tna';
import Comparer from '../../../quaity/compliance/Comparer';

const LEVEL_OPTIONS = ['n/a', 1, 2, 3];
const METHOD_OPTIONS = ['n/a', 'AL', 'CBT', 'Demo', 'DLA', 'DLS', 'e-learn', 'Lect', 'M-learn', 'MBT', 'Sim', 'WBT'];
const AID_OPTIONS = [
    'n/a',
    'Slideshow',
    'Manuals',
    'Computer',
    'Mobile',
    'Videos',
    'MSTD',
    'Mock-up',
    'VR',
    'MTD',
    'Real A/C',
    'A/C comp',
    'AR',
    'Embedded',
    'Classroom',
    'Virtual classroom',
    'Virtual A/C',
];

function TnaModuleEdit({ editingAta, editForm, setEditForm, handleCancelEdit, handleSaveEdit, showDiff, diffRow }) {
    const handleFormChange = (field, value) => {
        setEditForm((prev) => ({ ...prev, [field]: value }));
    };

    const [message, setMessage] = useState('');

    const handleCheckboxChange = (field, option) => {
        setEditForm((prev) => ({
            ...prev,
            [field]: prev[field].includes(option)
                ? prev[field].filter((item) => item !== option)
                : [...prev[field], option],
        }));
    };

    const genAi = async () => {
        // … your existing logic …
    };

    return (
        <div className={css.modalOverlay}>
            <div className={css.modal}>
                <h3 className={css.title}>
                    Edit ATA {editingAta.ataNo} - {editingAta.ataTitle}
                </h3>

                {/* Components + Diff */}
                <label className={css.label} htmlFor="comp">
                    Components:
                </label>
                <div className={showDiff ? css.twoCols : ''}>
                    <div className={css.formGroup}>
                        <textarea
                            id="comp"
                            className={css.textarea}
                            value={editForm.components}
                            onChange={(e) => handleFormChange('components', e.target.value)}
                            rows={4}
                            placeholder="Enter components (one per line)"
                        />
                    </div>

                    {showDiff && (
                        <div className={css.diffPanel}>
                            {isSame(diffRow?.fromComponents, diffRow?.toComponents) ? (
                                <div className={css.nd}>No Difference</div>
                            ) : (
                                <Comparer
                                    oldString={diffRow?.fromComponents || ''}
                                    newString={diffRow?.toComponents || ''}
                                />
                            )}
                        </div>
                    )}
                </div>

                {/* Objectives + Diff */}
                <label className={css.label} htmlFor="obj">
                    Objectives:
                </label>
                <div className={showDiff ? css.twoCols : ''}>
                    <div className={css.formGroup}>
                        <textarea
                            id="obj"
                            className={css.textarea}
                            value={editForm.objectives}
                            onChange={(e) => handleFormChange('objectives', e.target.value)}
                            rows={4}
                            placeholder="Enter objectives (one per line)"
                        />
                        <div className={css.inlineActions}>
                            <button type="button" className={css.secondaryButton} onClick={genAi}>
                                AI
                            </button>
                            <div className={css.message}>{message}</div>
                        </div>
                    </div>

                    {showDiff && (
                        <div className={css.diffPanel}>
                            {isSame(diffRow?.fromObjectives, diffRow?.toObjectives) ? (
                                <div className={css.nd}>No Difference</div>
                            ) : (
                                <Comparer
                                    oldString={diffRow?.fromObjectives || ''}
                                    newString={diffRow?.toObjectives || ''}
                                />
                            )}
                        </div>
                    )}
                </div>

                {/* Level + Diff */}
                <label className={css.label}>Level:</label>
                <div className={showDiff ? css.twoCols : ''}>
                    <div className={css.formGroup}>
                        <select
                            className={css.select}
                            value={editForm.level}
                            onChange={(e) => handleFormChange('level', e.target.value)}
                        >
                            <option value="">Select Level</option>
                            {LEVEL_OPTIONS.map((level) => (
                                <option key={level} value={level}>
                                    Level {level}
                                </option>
                            ))}
                        </select>
                    </div>

                    {showDiff && (
                        <div className={css.diffPanel}>
                            {isSame(diffRow?.maxFromLevel, diffRow?.maxToLevel) ? (
                                <div className={css.nd}>No Difference</div>
                            ) : (
                                <Comparer
                                    oldString={diffRow?.maxFromLevel || ''}
                                    newString={diffRow?.maxToLevel || ''}
                                />
                            )}
                        </div>
                    )}
                </div>

                {/* Aids */}
                <div className={css.formGroup}>
                    <label>Aids:</label>
                    <div className={css.checkboxGroup}>
                        {AID_OPTIONS.map((aid) => (
                            <label key={aid} className={css.checkboxLabel}>
                                <input
                                    type="checkbox"
                                    className={css.checkboxInput}
                                    checked={editForm.aids.includes(aid)}
                                    onChange={() => handleCheckboxChange('aids', aid)}
                                />
                                <span className={css.checkboxText}>{aid}</span>
                            </label>
                        ))}
                    </div>
                </div>

                {/* Methods */}
                <div className={css.formGroup}>
                    <label>Methods:</label>
                    <div className={css.checkboxGroup}>
                        {METHOD_OPTIONS.map((method) => (
                            <label key={method} className={css.checkboxLabel}>
                                <input
                                    type="checkbox"
                                    className={css.checkboxInput}
                                    checked={editForm.methods.includes(method)}
                                    onChange={() => handleCheckboxChange('methods', method)}
                                />
                                <span className={css.checkboxText}>{method}</span>
                            </label>
                        ))}
                    </div>
                </div>

                {/* Duration */}
                <div className={css.formGroup}>
                    <label htmlFor="dur">Duration (hh:mm):</label>
                    <input
                        id="dur"
                        className={css.timeInput}
                        type="time"
                        value={editForm.duration}
                        onChange={(e) => handleFormChange('duration', e.target.value)}
                        step="300"
                    />
                </div>

                {/* Footer */}
                <div className={css.modalActions}>
                    <button type="button" className={css.ghostButton} onClick={handleCancelEdit}>
                        Cancel
                    </button>
                    <button type="button" className={css.primaryButton} onClick={handleSaveEdit}>
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
}

export default TnaModuleEdit;
